import { View, Text, StyleSheet, Image } from 'react-native';
import colors from '../../constants/colors';
import { useState, useEffect } from 'react';
import { FaBriefcase } from "react-icons/fa";

const PotInfo = ({ data, showBB, message }) => {
  
  const [sidePots, setSidePots] = useState( data?.sidePots ?? []
  );
  const [pot, setPot] = useState(data?.pot ?? 0);
  const [tablePot, setTablePot] = useState(data?.tablePot ?? 0);
  const [isAnyActionComplete, setIsAnyActionComplete] = useState(data?.isAnyActionComplete);
  useEffect(() => {
    if (!data) return;

    //  Prepare base values first
    const filteredSidePots =
      data?.sidePots?.filter(e => e?.players?.length > 1 || e?.contribution?.length>1) ?? [];
    let potValue = data?.pot ?? 0;
    const tablePotValue = data?.tablePot ?? 0;
    let isActionCompleteT = data?.isAnyActionComplete ?? false;

    // Apply conditional logic
    console.log('before applying ----', message, data?.gameType);
    if (
      data?.gameType === 'TEXAS_HOLDEM_SIX_PLUS' &&
      (message === 'New hand started' || data?.board.length == 0)
    ) {
      const buttonBet = data?.seats?.[data?.button]?.bet ?? 0;
      // Sum of all seat bets safely
      const totalBets = Object.values(data?.seats ?? {}).reduce(
        (sum, seat) => sum + (seat?.bet ?? 0),
        0,
      );
      potValue = potValue - buttonBet;
      isActionCompleteT = true;
    }

    //  Update all states together (no race conditions)
   setSidePots(filteredSidePots);
    setPot(potValue);
   setTablePot(tablePotValue);
   setIsAnyActionComplete(isActionCompleteT); // Always true if any action completes
  }, [data]);

  const chunkArray = (arr, size) => {
    const chunked = [];
    for (let i = 0; i < arr.length; i += size) {
      chunked.push(arr.slice(i, i + size));
    }
    return chunked;
  };

  function formatNumber(n) {
    if (n === null || n === undefined || isNaN(n)) return '';

    return Number(n) % 1 === 0
      ? String(Number(n)) // whole number
      : Number(n).toFixed(2); // decimal → 2 places
  }

  const chipsPerRow = 3;

  const rows = chunkArray(sidePots.slice(1), chipsPerRow);
  return (
    <View style={styles.container}>
      <View style={styles.wrapper}>
       
        {rows.map((rowItems, rowIndex) => (
          <View key={rowIndex} style={styles.row2}>
            {rowItems
              .slice()
              .reverse()
              .map((item, index) =>
                item.amount > 0 ? (
                  <View>
                    {data?.potWiseInsurance.filter(
                      e => e.amount == item?.amount,
                    ).length > 0 ? (
                      <View
                        style={{
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <FaBriefcase 
                         
                          size={12}
                          style={{ marginLeft: 5 }}
                          color={'#964B00'}
                        />
                        <Text style={styles.insuraceAmount}>
                          {formatNumber(
                            data?.potWiseInsurance
                              ?.filter(
                                e => Number(e.amount) === Number(item?.amount),
                              )
                              ?.reduce(
                                (sum, e) => sum + Number(e.premium || 0),
                                0,
                              ),
                          )}
                        </Text>
                      </View>
                    ) : data?.potWiseInsurance?.filter(p =>
                        sidePots
                          .slice(1)
                          .map(s => Number(s.amount))
                          .includes(Number(p.amount)),
                      ).length > 0 ? (
                      <View style={{ width: 18, height: 23 }} />
                    ) : null}
                    <View key={index} style={styles.txtContainer}>
                      <Image
                        resizeMode="contain"
                        style={styles.chipIcon}
                        source={require('../../assets/inGameAssets/pinkChips.png')}
                      />
                      <Text style={styles.amount}>
                    {(() => {
  // normalize amount first
  let amount = Number(item?.amount || 0);
  amount = Number(amount.toFixed(2));

  const bb = Number(data?.bigBlind || 1);

  if (showBB) {
    let val = amount / bb;
    val = Number(val.toFixed(2));   // normalize again after division

    return Number.isInteger(val)
      ? `${val} BB`
      : `${val.toFixed(2)} BB`;
  } else {
    return Number.isInteger(amount)
      ? amount
      : amount.toFixed(2);
  }
})()}

                      </Text>
                    </View>
                  </View>
                ) : null,
              )}
          </View>
        ))}
      </View>

      <View style={styles.row}>
        {(
          Boolean(
          sidePots?.[0]?.amount > 0 && sidePots?.[0]?.contribution?.length > 1,
        )
          ||
          Boolean(
          sidePots?.[0]?.amount > 0 && sidePots?.[0]?.players?.length > 1,
        )) && (
          <View style={[styles.potCell, { position: 'absolute', left: -62 }]}>
            {data?.potWiseInsurance.filter(
              e => e.amount == sidePots?.[0]?.amount,
            ).length > 0 ? (
              <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                <FaBriefcase 
                 
                  size={12}
                  style={{ marginLeft: 5 }}
                  color={'#964B00'}
                />
                <Text style={styles.insuraceAmount}>
                  {formatNumber(
                    data?.potWiseInsurance
                      ?.filter(
                        e => Number(e.amount) === Number(sidePots?.[0]?.amount),
                      )
                      ?.reduce((sum, e) => sum + Number(e.premium || 0), 0),
                  )}
                </Text>
              </View>
            ) : data?.potWiseInsurance.filter(e => e.amount == pot).length >
              0 ? (
              <View style={{ width: 18, height: 23 }} />
            ) : null}

            <View style={styles.sidePot1Container}>
              <Image
                resizeMode="contain"
                style={styles.chipIcon}
                source={require('../../assets/inGameAssets/pinkChips.png')}
              />
              <Text style={styles.amount}>
                {(() => {
                  // normalize side pot amount first
                  let amount = Number(sidePots?.[0]?.amount || 0);
                  amount = Number(amount.toFixed(2)); // remove floating-point noise

                  const bb = Number(data?.bigBlind || 1);

                  if (showBB) {
                    let val = amount / bb;
                    val = Number(val.toFixed(2)); // normalize again after division

                    return Number.isInteger(val)
                      ? `${val} BB`
                      : `${val.toFixed(2)} BB`;
                  } else {
                    return Number.isInteger(amount)
                      ? amount
                      : amount.toFixed(2);
                  }
                })()}
              </Text>
            </View>
          </View>
        )}

        {isAnyActionComplete && pot > 0 ? (
          <View style={styles.potCell}>
            {data?.potWiseInsurance.filter(e => e.amount == pot).length > 0 ? (
              <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                <FaBriefcase 
                 
                  size={12}
                  style={{ marginLeft: 5 }}
                  color={'#964B00'}
                />
                <Text style={styles.insuraceAmount}>
                  {formatNumber(
                    data?.potWiseInsurance
                      ?.filter(e => Number(e.amount) === Number(pot))
                      ?.reduce((sum, e) => sum + Number(e.premium || 0), 0),
                  )}
                </Text>
              </View>
            ) : 
            data?.potWiseInsurance.filter(e => Number(e.amount) === Number(sidePots?.[0]?.amount)).length>0?
            <View style={{ width: 18, height: 23 }} />:
            null}

            <View style={styles.txtContainer}>
              <Image
                resizeMode="contain"
                style={styles.chipIcon}
                source={require('../../assets/inGameAssets/redChips.png')}
              />
              <Text style={styles.amount}>
              {(() => {
  // normalize pot first
  let amount = Number(pot || 0);
  amount = Number(amount.toFixed(2));

  const bb = Number(data?.bigBlind || 1);

  if (showBB) {
    let val = amount / bb;
    val = Number(val.toFixed(2));   // normalize again after division

    return Number.isInteger(val)
      ? `${val} BB`
      : `${val.toFixed(2)} BB`;
  } else {
    return Number.isInteger(amount)
      ? amount
      : amount.toFixed(2);
  }
})()}
              </Text>
            </View>
          </View>
        ) : null}
      </View>

      <Text style={styles.txt}>Pot</Text>
      <Text style={styles.tablePotTxt}>
      {(() => {
  // normalize table pot first
  let amount = Number(tablePot || 0);
  amount = Number(amount.toFixed(2));

  const bb = Number(data?.bigBlind || 1);

  if (showBB) {
    let val = amount / bb;
    val = Number(val.toFixed(2));   // normalize again after division

    return Number.isInteger(val)
      ? `${val} BB`
      : `${val.toFixed(2)} BB`;
  } else {
    return Number.isInteger(amount)
      ? amount
      : amount.toFixed(2);
  }
})()}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  wrapper: {
    flexDirection: 'column-reverse', // Bottom row appears first
  },

  chipIcon: {
    height: 10,
    width: 10,
    position: 'absolute',
    left: 2,
    top: 2,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  row2: {
    flexWrap: 'wrap',
    flexDirection: 'row',
    //backgroundColor:"red",
    alignItems: 'center',
    justifyContent: 'center',
  },
  txtContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: 'rgba(0,0,0,0.7)',
    width: 60,
    //marginLeft: 3,
    marginTop: 0.5,
    height: 15,
    borderRadius: 10,
  },
  txt: {
    fontSize: 10,
    color: colors.gray,
    fontStyle: 'AvertaStd-Regular',
  },
  insuraceAmount: {
    fontSize: 8,
    color: colors.gray,
    marginLeft: 3,
    fontFamily: 'AvertaStd-Regular',
    textAlign: 'center',
  },
  amount: {
    fontSize: 9,
    color: colors.white,
    marginLeft: 3,
    fontFamily: 'AvertaStd-Bold',
    textAlign: 'center',
  },
  sidePot1Container: {
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: 'rgba(0,0,0,0.7)',
    width: 60,
    height: 15,
    marginTop: 0.5,
    borderRadius: 10,
    //position: 'absolute',
    // left: -45,
  },
  tablePotTxt: {
    color: colors.primary,
    fontSize: 10,
    fontFamily: 'AvertaStd-Bold',
  },
  potCell: {
    flexDirection: 'column',
    alignItems: 'center',
    //backgroundColor:"red",
    justifyContent: 'center',
  },
});

export default PotInfo;
